export const PAGE_LABELS = {
  TITLE: "AI Analytics - Projects",
  CREATE_PROJECT: "New Project",
  SEARCH_PLACEHOLDER: "Search projects...",
} as const;

export const EMPTY_STATE_LABELS = {
  NO_PROJECTS: "No projects yet. Create one to get started.",
  NO_SEARCH_RESULTS: "No results found. Try a different search term.",
} as const;

export const DELETE_DIALOG = {
  TITLE: "Delete Project",
  CONFIRM: "Delete",
  CANCEL: "Cancel",
} as const;

export type SortField = "name" | "updatedAt";

export const SORT_FIELD_LABELS: Record<SortField, string> = {
  name: "Name",
  updatedAt: "Date Updated",
};

export const TAB_VALUES = {
  MY: "my",
  SHARED: "shared",
  ADMIN: "admin",
} as const;

export type Tab = (typeof TAB_VALUES)[keyof typeof TAB_VALUES];

export const TAB_LABEL_BY_VALUE: Record<Tab, string> = {
  my: "My Projects",
  shared: "Shared With Me",
  admin: "Admin",
};
